import axios from "axios";
import store from "@/store";

const requests = {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        async getRequests() {
            let response = await axios.get(`/get_requests/${store.state.userName}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getVoiceLogs(context, payload) {
            let response = await axios.get(`/get_voice_log/${payload.startDate}/${payload.endDate}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getLocations(context, payload) {
            let response = await axios.post(`/get_location`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getFinanceServiceStatus() {
            let response = await axios.get(`/finance_center_is_live`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async issueFinanceDocument(context, payload) {
            let response = await axios.get(`/run_create_finance/${payload.Sale_Num}/${payload.Sale_Kind}/${payload.Cs_Code}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async issueFinanceDocumentBuyFac(context, payload) {
            let response = await axios.get(`/run_create_finance_buy_fac/${payload.Sale_Num}/${payload.Sale_Kind}/${payload.Cs_Code}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async setFactorSaleState(context, payload) {
            let response = await axios.get(`/set_factor_Sale_State/${payload.sale_num}/${payload.state}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
    },
    getters: {}
}

export default requests;
